import React, { Fragment } from 'react';
import Navbar from '../../components/Navbar/Navbar';
import PageTitle from '../../components/pagetitle/PageTitle'
import Scrollbar from '../../components/scrollbar/scrollbar'
import { useParams } from 'react-router-dom'
import Footer from '../../components/footer/Footer';
import Practices from '../../api/Practices';
import Sidebar from './Sidebar';
import FaqSection from './FaqSection';


const PracticeSinglePage = (props) => {
    const { slug } = useParams()

    const PracticeDetails = Practices.find(item => item.slug === slug)

    return (
        <Fragment>
            <Navbar hclass={'wpo-header-style-5'} topbarClass={'tb-block'} />
            <PageTitle pageTitle={PracticeDetails.sTitle} pagesub={'Project'} />

            <section className="wpo-service-single-section section-padding">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-8 col-md-12 order-lg-2 order-1">
                            <div className="wpo-service-single-wrap">
                                <div className="wpo-service-single-content">
                                    <img src={PracticeDetails.simg} alt="" />
                                    <div className="wpo-service-single-content-des">
                                        <h2>{PracticeDetails.sTitle}</h2>
                                        <p>{PracticeDetails.description}</p>
                                        <p>{PracticeDetails.des2}</p>
                                        <p>{PracticeDetails.des3}</p>
                                    </div>
                                  
                                </div>
                                <div className="wpo-faq-section">
                                    <h2>Questions You May Wonder?</h2>
                                    <p>The types of damages that can be claimed in a personal injury suit. Here is a run down of some common types of damagesPellentesque sit tortor eu proin at commodo.</p>
                                    <div className="row">
                                        <div className="col-lg-12 col-12">
                                            <div className="wpo-faq-item">
                                                <FaqSection/>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <Sidebar/>
                    </div>
                </div>
            </section>
            <Footer />
            <Scrollbar />
        </Fragment>
    )
};
export default PracticeSinglePage;
